// src/pages/AboutPage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PageBack } from '../components/shared/PageBack';

const AboutPage = () => {
  const navigate = useNavigate();
  return (
    <div style={s.page}>
      <button onClick={() => navigate(-1)} style={s.back}>
        <div style={s.backCircle}>←</div>
        <span style={s.backLbl}>Back</span>
      </button>

      <div style={s.logo}>🌿</div>
      <h1 style={s.h1}>About Gather</h1>
      <p style={s.lead}>
        Gather is a free community noticeboard for your town. One place to see everything that's happening locally — no algorithm, no ads, no login needed to browse.
      </p>

      <div style={s.section}>
        <div style={s.sectionTitle}>Why we built it</div>
        <p style={s.body}>
          In rural Ireland, events get lost across Facebook groups, noticeboards, and word of mouth. People miss things happening in their own town. Gather fixes that — one clear place for everything local.
        </p>
      </div>

      <div style={s.section}>
        <div style={s.sectionTitle}>Accessibility & open information</div>
        <p style={s.body}>
          We believe information about your own community shouldn't have barriers around it — including barriers around who can actually use Gather. It's part of why Gather exists at all, not a feature we bolted on.
        </p>
        <button onClick={() => navigate('/accessibility')} style={s.linkBtn}>Read about accessibility at Gather →</button>
      </div>

      <div style={s.section}>
        <div style={s.sectionTitle}>How it works</div>
        <div style={s.stepList}>
          {[
            ['📅', 'Local organisers post events for free'],
            ['🔍', 'Residents browse without needing an account'],
            ['❤️', 'Mark what you\'re interested in'],
            ['📲', 'Add Gather to your home screen for easy access'],
          ].map(([emoji, text]) => (
            <div key={text} style={s.step}>
              <span style={s.stepEmoji}>{emoji}</span>
              <span style={s.stepText}>{text}</span>
            </div>
          ))}
        </div>
      </div>

      <div style={s.section}>
        <div style={s.sectionTitle}>Who's behind it</div>
        <p style={s.body}>
          Gather is built by Clement & Grace Limited, a small Irish startup based in Loughrea, Co. Galway. We're community people building tools for community people.
        </p>
      </div>

      <div style={s.card}>
        <div style={s.cardText}>Got a question or want to bring Gather to your town?</div>
        <button onClick={() => navigate('/contact')} style={s.contactBtn}>Get in touch</button>
      </div>
      <PageBack position="bottom" fallbackPath="/profile" />
    </div>
  );
};

const s = {
  page: { background: '#fff', minHeight: '100vh', padding: '52px 24px 60px', maxWidth: 430, margin: '0 auto' },
  back: { display: 'flex', alignItems: 'center', gap: 8, background: 'none', border: 'none', cursor: 'pointer', marginBottom: 24 },
  backCircle: { width: 34, height: 34, background: '#F8FBF8', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, color: '#2C4A2E' },
  backLbl: { fontSize: 13, color: '#4A6A4A', fontWeight: 600 },
  logo: { fontSize: 40, marginBottom: 12 },
  h1: { fontSize: 28, fontWeight: 800, color: '#1A2E1A', marginBottom: 12, letterSpacing: '-0.3px' },
  lead: { fontSize: 16, color: '#2C4A2E', lineHeight: 1.6, marginBottom: 32, fontWeight: 500 },
  section: { marginBottom: 28 },
  sectionTitle: { fontSize: 13, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1.2px', color: '#1A7A4A', marginBottom: 10 },
  body: { fontSize: 15, color: '#3A5A3A', lineHeight: 1.7, margin: 0 },
  linkBtn: { background: 'none', border: 'none', color: '#1A7A4A', fontWeight: 700, fontSize: 14, cursor: 'pointer', padding: 0, marginTop: 10, fontFamily: 'Nunito, sans-serif' },
  stepList: { display: 'flex', flexDirection: 'column', gap: 12 },
  step: { display: 'flex', alignItems: 'center', gap: 12, background: '#F8FBF8', borderRadius: 12, padding: '12px 14px' },
  stepEmoji: { fontSize: 20, flexShrink: 0 },
  stepText: { fontSize: 14, color: '#2C4A2E', fontWeight: 600 },
  card: { background: '#EBF2EB', borderRadius: 16, padding: '20px', textAlign: 'center', marginTop: 12 },
  cardText: { fontSize: 14, color: '#2C4A2E', fontWeight: 500, marginBottom: 14, lineHeight: 1.5 },
  contactBtn: { background: '#1A7A4A', color: 'white', border: 'none', borderRadius: 12, padding: '12px 24px', fontSize: 14, fontWeight: 700, fontFamily: 'Nunito, sans-serif', cursor: 'pointer' },
};

export default AboutPage;
